/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-15 08:35:47
 * @Description: 不可进行二次销售
 */
import request from '@/utils/request'
import { del } from 'vue'

/**
 * 作品管理相关接口
 */
export default {
  /**
   * 获取作品列表
   */
  getList(params) {
    return request({
      url: '/shop/video',
      method: 'get',
      params
    })
  },

  /**
   * 获取作品详情
   * @param {number|string} id - 作品ID
   */
  getInfo(id) {
    return request({
      url: `/shop/video/${id}`,
      method: 'get'
    })
  },

  /**
   * 创建作品
   * @param {Object} data - 作品数据
   */
  create(data) {
    if(data.id>0){
      return request({
        url: `/shop/video/${data.id}`,
        method: 'put',
        data
      })
    }
    return request({
      url: '/shop/video',
      method: 'post',
      data
    })
  },
 /**
   * 删除作品
   * @param {number|string} id - 作品ID
   */
  delete(id) {
    return request({
      url: `/shop/video/work/${id}`,
      method: 'delete'
    })
  },
  /**
   *批量添加集
   * @param {number|string} id - 作品ID
   * @param {Object} data - 数据
   */
  addEpisode(id, data) {
    return request({
      url: `/shop/video/batchwork/${id}`,
      method: 'post',
      data
    })
  },
/**
 * 删除集
*/
 deleteEpisode(id) {
   return request({
      url: `/shop/video/work/${id}`,
      method: 'delete'
    })
  },
  updateWorkSetting( data) {
    return request({
      url: `/shop/video/work/setting`,
      method: 'put',
      data
    })
  },
  getAllVideo( data) {
    return request({
      url: `/shop/video/all/list`,
      method: 'get',
      data
    })
  }
}